import { getRecentArts, getSharedArts, getUserImageAccess } from '../../userimage/selectors';

import { artType } from '../constants';
import { createSelector } from '@reduxjs/toolkit';
import { getCurrentImprintFormat } from '../../imprintarea/selectors';
import { getNextgenUiStatus } from '../sidebar/LeftFlyout/selectors';
import { userImageType } from '../../utils/constants';

export const getUploadPanelRecentArt = createSelector(getRecentArts, (recent) => {
  const uploadRecentArts = recent.list.filter(
    (art) =>
      art.type === userImageType.UploadLogo ||
      art.type === userImageType.SavedArt ||
      art.type === userImageType.SharedArt
  );
  return { count: uploadRecentArts.length, list: uploadRecentArts };
});
export const getSavedArtList = createSelector(
  (state) => state.savedArtDict,
  getCurrentImprintFormat,
  (savedArtDict, format) => {
    const key = `${format.imprintAreaCode}-${format.processType}`;
    return savedArtDict[key] || [];
  }
);
export const allowUploadArtType = createSelector(
  getUserImageAccess,
  getSavedArtList,
  getSharedArts,
  getUploadPanelRecentArt,
  (access, saved, shared, recent) => {
    const allowRecent = access.recent && recent.count > 0;
    let allowSavedOrShared = (access.saved && saved.length > 0) || (access.shared && shared.count > 0);
    return [allowSavedOrShared && artType.Saved, allowRecent && artType.Recent].filter(Boolean);
  }
);

export const getUploadMultipleCount = createSelector(getNextgenUiStatus, (nextgenUiStatus) => {
  return (nextgenUiStatus.uploadMultiple && nextgenUiStatus.uploadMultiple.uploadMultipleCount) || 0;
});
